export default __webpack_public_path__ + "static/media/signup-featured.c7523d382926baa99e55068081c2e917.svg";